import { upToDateSkillsetCourses } from "../const/course";

export function getUpToDateSkillsetCourse(courseId?: string) {
  return upToDateSkillsetCourses.find((course) => course.id === courseId);
}
